module.exports = __webpack_public_path__ + "public/img/activeBanner.0fa3f885.png";